<template>
  <div>
    <MainContainer :zoom="zoom" :center="center" :idProvince="idProvince" />
  </div>
</template>

<script>
import MainContainer from '@/view/components/MainContainer.vue'
export default {
  name: 'jateng',
  components: {
    MainContainer,
  },
  data: function () {
    return {
      zoom: 8,
      center: [-7.1445151, 110.1860489],
      idProvince: '33',
    }
  },
}
</script>

<style lang="scss" scoped></style>
